export class EnterpriseBillReaderUploadBanner {
	public type: 'error' | 'pending' | 'unmatchedLocation';
	public cssClass: string;
	public icon: string[];
	public message: string;

	constructor(data?: EnterpriseBillReaderUploadBanner) {
		Object.assign(this, data);
	}
}
